module.exports = ".buttons button{margin-right:5px}.buttons select{max-width:200px;margin-bottom:5px}"